{
    "_comment": "This file was generated by git-version.js in the project root.",
    "gitRef": ""
}
